import { SHOW_NOTIFICATION, HIDE_NOTIFICATION } from './../actions/notification';

const initialState = {
  notificationProps: {
    show: false,
    title: '',
    msg: '',
  }
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        notificationProps: action.notificationProps
      };
    case HIDE_NOTIFICATION:
      return {
        notificationProps: action.notificationProps
      };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/notification.js